var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-icon"},[_c('font-awesome-icon',{attrs:{"icon":['fal', _vm.customIcon],"title":_vm.title,"size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }